'use strict';

import FavoritesService from '../../services/favorites';

const favorites = {
  namespaced: true,
  state: {
    favorites: []
  },
  mutations: {
    setFavorites (state, favorites) {
      state.favorites = favorites;
    }
  },
  actions: {
    get ({commit}) {
      if ( !!localStorage.favorites ) {
        commit('setFavorites', JSON.parse(localStorage.getItem('favorites')));
      }
      else {
        FavoritesService.get().then(
          response => {
            let favorites = response.data.favorites.edges;
            localStorage.setItem('favorites', JSON.stringify(favorites));
            commit('setFavorites', favorites);
          }
        );
      }
    },

    refresh ({commit, state, dispatch}) {
      localStorage.removeItem('favorites');
      dispatch('get');
    }
  }
};

export default favorites;



// WEBPACK FOOTER //
// ./app/javascript/vue/vuex/modules/favorites.js